import classNames from "classnames";
import { useEffect } from "react";
import { ModalClose } from "@/public/icons/ModalClose";
import styles from "./Modal.module.scss";

type ModalStyles = {
  modal?: string;
  close?: string;
  title?: string;
  body?: string;
};

type ModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpened: boolean) => void;
  title: string;
  overrideStyles?: ModalStyles;
  children: React.ReactNode;
  onClose?: () => void;
  buttonType?: "button" | "submit" | "reset";
};

export const Modal = ({
  isOpen,
  setIsOpen,
  onClose,
  title,
  overrideStyles,
  children,
  buttonType = "submit",
}: ModalProps) => {
  function closeModale() {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  }

  // Locking the scroll
  useEffect(() => {
    document.body.style.overflowY = isOpen ? "hidden" : "scroll";

    return () => {
      document.body.style.overflowY = "scroll";
    };
  }, [isOpen]);

  return (
    <div
      className={classNames(styles.modalContainer, {
        [styles.opened]: isOpen,
      })}
    >
      <div className={styles.backdrop} onClick={() => closeModale()} />
      <div className={classNames(styles.modal, overrideStyles?.modal)}>
        <button
          type={buttonType}
          className={classNames(styles.modalClose, overrideStyles?.close)}
          onClick={closeModale}
        >
          <ModalClose color="#062E5E" width="50" height="50" />
        </button>
        <div className={classNames(styles.modalTitle, overrideStyles?.title)}>
          {title}
        </div>
        <div className={(styles.modalBody, overrideStyles?.body)}>
          {children}
        </div>
      </div>
    </div>
  );
};
